import { ICountry } from "@myinnsworth/models/address/ICountry";
import { IApplicant } from "@myinnsworth/models/applicants/IApplicant";
import ICase from "@myinnsworth/models/case/ICase";
import { createContext } from "react";

export interface IAppStoreContext {
    cases: Array<ICase>;
    countries: Array<ICountry>;
    setCurrentApplicant: (applicant: IApplicant) => void;
    currentApplicant?: IApplicant;
}

const AppStoreContext = createContext<IAppStoreContext>({ cases: [], countries: [], currentApplicant: undefined, setCurrentApplicant: (applicant: IApplicant) => { }});
export default AppStoreContext;